export class AppConfig {
    public static CURRENT_USER = 'user';
    public static BACKEND_FORMAT_DATETIME = 'DD.MM.YYYY HH:mm:ss';
    public static BACKEND_FORMAT_DATE = 'DD.MM.YYYY';
    public static BACKEND_FORMAT_TIME = 'HH:mm:ss';
    public static FRONTED_FORMAT_DATE = 'DD.MM.YYYY';
    public static FRONTEND_FORMAT_DATETIME = 'DD.MM.YYYY HH:mm:ss';
}
